<template>
  <div class="card card-custom gutter-b">
    <!--begin::Header-->
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">{{ $t('ECOMMERCE.WELCOME') }}</span>
        <span class="text-muted mt-3 font-weight-bold font-size-sm"></span>
      </h3>
      <div class="card-toolbar">
        <a href="#/shop/All products" class="btn btn-light-primary font-weight-bolder font-size-sm"
          >{{ $t('ECOMMERCE.VIEW_ALL') }}</a
        >
      </div>
    </div>
    <!--end::Header-->
    <!--begin::Body-->
    <div class="card-body py-0">

<!-- <div class="card card-custom gutter-b">
    <div class="card-body rounded p-0 d-flex bg-light">
        <div class="d-flex flex-column flex-lg-row-auto w-auto w-lg-350px w-xl-450px w-xxl-650px py-10 py-md-14 px-10 px-md-20 pr-lg-0">
            <h1 class="font-weight-bolder text-dark mb-0">Search Goods</h1>
            <div class="font-size-h4 mb-8">Get Amazing Gadgets</div>
            <form class="d-flex flex-center py-2 px-6 bg-white rounded">
                <span class="svg-icon svg-icon-lg svg-icon-primary">
					<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
						<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
							<rect x="0" y="0" width="24" height="24"></rect>
						</g>
					</svg>
				</span>
			<input type="text" class="form-control border-0 font-weight-bold pl-2" placeholder="Search Goods">
            </form>
        </div>
        <div class="d-none d-md-flex flex-row-fluid bgi-no-repeat bgi-position-y-center bgi-position-x-left bgi-size-cover" style="background-image: url(https://preview.keenthemes.com/metronic/theme/html/demo1/dist/assets/media/svg/illustrations/copy.svg);">
        </div>
    </div>
</div> -->

<!-- <div class="row">
	<div class="col-md-8 col-lg-12 col-xxl-8">
	<div class="card card-custom card-stretch card-stretch-half gutter-b overflow-hidden">
		<div class="card-body p-0 d-flex rounded bg-light-success">
			<div class="py-18 px-12">
				<h3 class="font-size-h1"><a href="#" class="text-dark font-weight-bolder">Nike Sneakers</a></h3>
				<div class="font-size-h4 text-success">Get Amazing Nike Sneakers</div>
			</div>
						<div class="d-none d-md-flex flex-row-fluid bgi-no-repeat bgi-position-y-center bgi-position-x-left bgi-size-cover" style="transform: scale(1.0) rotate(-26deg); background-image: url('https://preview.keenthemes.com/metronic/theme/html/demo1/dist/assets/media/products/13.png')"></div>
				</div>
	</div>
	<div class="card card-custom card-stretch card-stretch-half gutter-b overflow-hidden">
		<div class="card-body p-0 d-flex rounded bg-light-danger">
			<div class="py-18 px-12">
				<h3 class="font-size-h1"><a href="#" class="text-dark font-weight-bolder">Nike Sneakers</a></h3>
				<div class="font-size-h4 text-danger">Get Amazing Nike Sneakers</div>
			</div>
						<div class="d-none d-md-flex flex-row-fluid bgi-no-repeat bgi-position-y-center bgi-position-x-left bgi-size-cover" style="transform: scale(1.0) rotate(-26deg); background-image: url('https://preview.keenthemes.com/metronic/theme/html/demo1/dist/assets/media/products/12.png')"></div>
				</div>
	</div>
	</div>
	<div class="col-md-4 col-lg-12 col-xxl-4">
		<div class="card card-custom card-stretch gutter-b">
			<div class="card-body d-flex flex-column rounded bg-light-primary justify-content-between">
				<div class="rounded text-center mb-7 pt-7">
					<img src="https://preview.keenthemes.com/metronic/theme/html/demo1/dist/assets/media/products/14.png" class="mw-100 w-200px" style="transform: scale(1.4);">
				</div>
				<div class="text-center">
					<h3 class="font-size-h1"><a href="#" class="text-dark font-weight-bolder">Kanken</a></h3>
					<div class="font-size-h4 text-primary">Amazing Backpack</div>
				</div>
			</div>
		</div>
	</div>
</div> -->
      	<div class="mb-11">
			<!--begin::Heading-->
			<!-- <div class="d-flex justify-content-between align-items-center mb-7">
				<h2 class="font-weight-bolder text-dark font-size-h3 mb-0">{{ $t('TRANSLATOR.CATEGORIES', { msg: 'CATEGORIES' }) }}</h2>
				<a href="#/shop/All products" class="btn btn-light-primary btn-sm font-weight-bolder">View All</a>
			</div> -->
			<!--end::Heading-->

			<!--begin::Products-->
			<div class="row">
            	<template v-for="(item, id) in categories">
					<!--begin::Product-->
					<div class="col-sm-6 col-md-3 col-xxl-2" v-bind:key="id">
						<!--begin::Card-->
						<div class="card card-custom card-shadowless">
							<div class="card-body p-0">
								<!--begin::Image-->
								<div class="overlay">
									<div class="overlay-wrapper rounded bg-light text-center">
										<img :src=item.ImgUrl alt="" class="mw-100 w-200px">
									</div>
									<div class="overlay-layer">
										<a v-bind:href="`#/shop/${item.url}`" class="btn font-weight-bolder btn-sm btn-primary mr-2">{{ $t('ECOMMERCE.VIEW') }}</a>
									</div>
								</div>
								<!--end::Image-->

								<!--begin::Details-->
								<div class="text-center mt-5 mb-md-0 mb-lg-5 mb-md-0 mb-lg-5 mb-lg-0 mb-5 d-flex flex-column">
									<a v-bind:href="`#/shop/${item.ImgUrl}`" class="font-size-h5 font-weight-bolder text-dark-75 text-hover-primary mb-1">{{ item.description }}</a>
									<span class="font-size-lg">Outlines keep poorly thought</span>
								</div>
								<!--end::Details-->
							</div>
						</div>
						<!--end::Card-->
					</div>
					<!--end::Product-->
            	</template>
			</div>
			<!--end::Products-->
		</div>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
export default {
  name: "widget-1",
  data() {
    return {
      categories: [
	  	{
			id: 1,
			description: 'Motors',
			url: 'Motors',
			ImgUrl: 'media/max-line/motors.jpg',
		},
		{
			id: 2,
			description: 'Bearings',
			url: 'Bearings',
			ImgUrl: 'media/max-line/bearings.jpg',
		},
		{
			id: 3,
			description: 'Sprockets',
			url: 'Sprockets',
			ImgUrl: 'media/max-line/sprockets.jpg',
		},
		{
			id: 4,
			description: 'Chains & Belts',
			url: 'ChainsBelts',
			ImgUrl: 'media/max-line/chainbelt.jpg',
		},
		{
			id: 5,
			description: 'Curves',
			url: 'Curves',
			ImgUrl: 'media/max-line/curves.jpg',
		},
		{
			id: 6,
			description: 'Wearstrips',
			url: 'Wearstrips',
			ImgUrl: 'media/max-line/wearstrip.jpg',
		},
		{
			id: 7,
			description: 'Rollers',
			url: 'Rollers',
			ImgUrl: 'media/max-line/rollers.jpg',
		},
		{
			id: 8,
			description: 'Components',
			url: 'Components',
			ImgUrl: 'media/max-line/components.jpg',
		},

	],
    };
  },
  components: {},
  methods: {}
};
</script>
